import PageBanner from "../components/PageBanner";
import Counter from "../components/Counter";
import aboutData from "../data/about.json";
import officers from "../data/officers.json";

export default function About() {
  const { story, mission, achievements } = aboutData;
  
  // Later replace this with API value
  const aboutImage = null; // or "" or undefined

  return (
    <div className="bg-gray-50">
      {/* BANNER */}
      <PageBanner
        title="About RDCA"
        subtitle="Learn about our mission to promote chess excellence in Ranipet District"
        image="/images/chess.png"
      />

      {/* OUR STORY */}
      {/* OUR STORY */}
{/* ABOUT / STORY */}
<section className="py-24 bg-gradient-to-b from-white to-gray-50">
  <div className="max-w-7xl mx-auto px-6">
    
    <h2 className="text-4xl font-bold text-blue-700 mb-16 text-center">
      About RDCA
    </h2>

    <div className="grid md:grid-cols-12 gap-14 items-center">

      {/* TEXT */}
      <div className="md:col-span-7">
        <div className="bg-white rounded-2xl shadow-xl p-10 border relative">
          
          <div className="absolute top-0 left-0 w-24 h-1 bg-blue-600 rounded-tl-2xl"></div>

          <h3 className="text-2xl font-semibold text-gray-800 mb-4">
            Who We Are
          </h3>

          <p className="text-lg text-gray-700 leading-relaxed mb-8">
            {story}
          </p>

          <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg">
            <h4 className="text-xl font-semibold text-gray-800 mb-2">
              Our Impact
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              {achievements}
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT – IMAGE */}
      <div className="md:col-span-5">
        <div className="h-64 sm:h-80 rounded-2xl overflow-hidden shadow-xl border border-gray-200">
          <img
            src={aboutImage || "/images/chessabout.webp"}
            alt="About RDCA"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            onError={(e) => {
              e.currentTarget.src = "/images/chessabout.webp";
            }}
          />
        </div>
      </div>

    </div>
  </div>
</section>

      {/* ACHIEVEMENTS */}
<section className="py-24 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6">

    <h2 className="text-4xl font-bold text-blue-700 mb-16 text-center">
      Our Achievements
    </h2>

    <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-10">
      {[
        { label: "State Champions", value: 25 },
        { label: "National Players", value: 10 },
        { label: "Tournaments Hosted", value: 150 },
        { label: "Active Players", value: 500 },
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-2xl shadow-lg p-10 text-center border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition"
        >
          <h3 className="text-5xl font-bold text-blue-700 mb-3">
            <Counter end={item.value} />
          </h3>
          <p className="text-lg text-gray-600">
            {item.label}
          </p>
        </div>
      ))}
    </div>

  </div>
</section>



     {/* MISSION & VISION */}
<section className="py-24 bg-gradient-to-b from-gray-50 to-white">
  <div className="max-w-7xl mx-auto px-6">

    <h2 className="text-4xl font-bold text-blue-700 mb-16 text-center">
      Our Mission & Vision
    </h2>

    <div className="grid md:grid-cols-2 gap-14">

      {/* MISSION */}
      <div className="bg-white rounded-2xl shadow-xl p-10 border relative hover:-translate-y-1 transition duration-300">
        <div className="absolute top-0 left-0 w-24 h-1 bg-blue-600 rounded-tl-2xl"></div>

        <h3 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center gap-3">
  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
    ♟️
  </div>
  Our Mission
</h3>
        <ul className="space-y-4">
          {mission.map((item, i) => (
            <li
              key={i}
              className="flex items-start gap-3 text-lg text-gray-700"
            >
              <span className="text-blue-600 font-bold">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* VISION */}
      <div className="bg-blue-50 rounded-2xl shadow-xl p-10 border relative hover:-translate-y-1 transition duration-300">
        <div className="absolute top-0 left-0 w-24 h-1 bg-blue-700 rounded-tl-2xl"></div>

        <h3 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center gap-3">
  <div className="w-10 h-10 rounded-full bg-blue-200 flex items-center justify-center">
    👁️
  </div>
  Our Vision
</h3>

        <p className="text-lg text-gray-700 leading-relaxed">
          To make Ranipet District a recognized hub for chess excellence by
          nurturing disciplined, ethical, and competitive players who can
          perform at state, national, and international levels.
        </p>
      </div>

    </div>
  </div>
</section>


      {/* QUICK FACTS */}
      {/* QUICK FACTS */}


      {/* OFFICERS */}
<section className="py-24 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6 text-center">

    <h2 className="text-4xl font-bold text-blue-700 mb-16">
      Our Officers
    </h2>

    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-12">
      {officers.map(o => (
        <div
          key={o.id}
          className="group bg-white rounded-2xl shadow-xl overflow-hidden border hover:-translate-y-2 hover:shadow-2xl transition duration-300"
        >
          {/* PHOTO */}
         <div className="h-64 w-full bg-gray-100 overflow-hidden">
 <img
  src={`/images/p${o.id}.jpg`}
  alt={o.name}
  onError={(e) => {
    // Try jpg first, then png, then webp
    const extensions = ['.jpg', '.png', '.webp'];
    let tried = 0;
    
    const tryNextExtension = () => {
      if (tried < extensions.length) {
        e.currentTarget.src = `/images/p${o.id}${extensions[tried]}`;
        tried++;
      }
    };
    
    tryNextExtension();
  }}
  className="w-full h-full object-cover object-[50%_10%] grayscale group-hover:grayscale-0 group-hover:scale-110 transition duration-500"
/>

</div>


          {/* CONTENT */}
          <div className="p-8 text-center">
            {/* ROLE BADGE */}
            <span className="inline-block mb-3 px-4 py-1 text-sm font-semibold rounded-full bg-blue-100 text-blue-700">
              {o.designation}
            </span>

            <h3 className="text-xl font-bold text-gray-800">
              {o.name}
            </h3>

            {/* CONTACT */}
            <div className="mt-6 space-y-3 text-sm text-gray-700">

              {/* PHONE */}
              <div className="flex items-center justify-center gap-2">
                <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h2.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-1.6.8a11.042 11.042 0 005.516 5.516l.8-1.6a1 1 0 011.21-.502l4.493 1.498A1 1 0 0121 17.72V20a2 2 0 01-2 2h-1C9.716 22 2 14.284 2 5V5z" />
                </svg>
                <span>{o.mobile}</span>
              </div>

              {/* EMAIL */}
              <div className="flex items-center justify-center gap-2">
                <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>{o.email}</span>
              </div>

            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>

    </div>
  );
}